import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

export const removeUndeclaredItemFromProcessingSession = {
  name: "removeUndeclaredItemFromProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    sessionItemId: processingSessionItemIdFormat.schema,
  }),
  output: z.object({ session: ProcessingSession }),
};
